<mat-button-toggle-group
  [value]="value()"
  [attr.aria-label]="ariaLabel() || null"
  (change)="value.set($event.value)"
>
  @for (option of options(); track option.value) {
    <mat-button-toggle
      [value]="option.value"
      [title]="option.labelKey | translate"
    >
      {{ option.labelKey | translate }}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
